module.exports = __webpack_public_path__ + "media/press/NEWheader-f79ce378.png";